import React, { useEffect, useState } from "react";
import styled from "styled-components";
import axios from "axios";
import SnackbarCustomized from "./common/Snackbar";
import { changeUserPassword } from "../services/userService";
import { deviceSize } from "./common/Breakpoints";

function SettingsFormChangePassword() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("Password updated");
  const [snackbarBgColor, setSnackbarBgColor] = useState("#caf0f8");

  //   useEffect(async () => {
  //     const response = await getMyUserInfo();
  //     if (response && response.status === 200) {
  //       setFirstName(response.data.firstName);
  //       setLastName(response.data.lastName);
  //     }
  //   }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setOpenSnackbar(true);
      setSnackbarMessage("New / confirm password do not match ");
      setSnackbarBgColor("#ff8484");
    } else {
      const data = {
        currentPassword: currentPassword,
        newPassword: newPassword,
      };
      const response = await changeUserPassword(data);
      if (response && response.status === 200) {
        setOpenSnackbar(true);
        setSnackbarMessage("Password updated");
        setSnackbarBgColor("#caf0f8");
        setCurrentPassword("")
        setNewPassword("")
        setConfirmPassword("")
      } else {
        setOpenSnackbar(true);
        setSnackbarMessage(response);
        setSnackbarBgColor("#ff8484");
      }
    }
  };

  const closeSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <Container>
      <SnackbarCustomized
        onOpen={openSnackbar}
        onCloseSnackbarParent={closeSnackbar}
        message={snackbarMessage}
        backgroundcolor={snackbarBgColor}
        textcolor={"#495057"}
      />
      <StyledFormTitle>Change password</StyledFormTitle>
      <StyledForm
        onSubmit={(e) => {
          handleSubmit(e);
        }}
      >
        <StyledLabel htmlFor="currentPassword">Current password:</StyledLabel>
        <br />
        <StyledTextInput
          id="currentPassword"
          name="currentPassword"
          type="password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
        />
        <br />
        <StyledLabel htmlFor="newPassword">New password:</StyledLabel>
        <br />
        <StyledTextInput
          id="newPassword"
          name="newPassword"
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        <br />
        <StyledLabel htmlFor="confirmPassword">
          Confirm new password:
        </StyledLabel>
        <br />
        <StyledTextInput
          id="confirmPassword"
          name="confirmPassword"
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
        <StyledSubmitContainer>
          <StyledSubmit type="submit" value="Change" />
        </StyledSubmitContainer>
      </StyledForm>
    </Container>
  );
}

export default SettingsFormChangePassword;

const Container = styled.div`
  width: 100%;
  /* max-width: 800px; */
  display: flex;
  flex-direction: column;
  /* overflow: scroll; */
  justify-content: flex-start;
  align-items: flex-start;
  /* margin-left: 25px; */
  border-radius: 10px;
  background-color: white;
  padding-left: 30px;
  padding-top: 15px;
  padding-bottom: 15px;
  @media (max-width: ${deviceSize.tablet}px) {
    padding-left: 0px;
  }
`;

const StyledFormTitle = styled.h2`
  font-family: "Comfortaa";
  font-size: 16px;
  color: #77727a;
  font-weight: 300;
  margin-bottom: 10px;
`;

const StyledForm = styled.form`
  width: 100%;
`;

const StyledLabel = styled.label`
  font-family: "Comfortaa";
  font-size: 11px;
  color: #77727a;
  font-weight: 300;
  position: relative;
  top: 9px;
  left: 19px;
  background-color: white;
`;

const StyledTextInput = styled.input`
  width: 50%;
  height: 40px;
  min-width: 250px;
  max-width: 500px;
  font-family: "Comfortaa";
  flex: 1;
  outline: 0;
  border: 1px solid whitesmoke;
  border-radius: 8px;
  background-color: white;
  padding: 0 12px;
  font-size: 12px;
  font-weight: 300;
  letter-spacing: 0.5px;
  color: #303030;
  /* text-transform: uppercase; */
  /* box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
    rgba(0, 0, 0, 0.3) 0px 1px 3px -1px; */
  @media (max-width: ${deviceSize.tablet}px) {
    min-width: 200px;
  }
  @media (max-width: ${deviceSize.mobile}px) {
    min-width: 150px;
  }
`;

const StyledSubmitContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 30px;
  margin-right: 50px;
  margin-bottom: 30px;
`;

const StyledSubmit = styled.input`
  border-radius: 4px;
  text-decoration: none;
  border: none;
  text-align: center;
  font-family: "Comfortaa";
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
  padding: 13px 13px;
  background-color: #04a1c4;
  color: #fff;
  text-transform: uppercase;
  cursor: pointer;

  :hover {
    opacity: 0.7;
  }
  :active {
    transform: scale(1.05);
    box-shadow: rgba(0, 0, 0, 0.18) 2px 6px 10px;
  }
`;
